import { LoadablePaint } from '@confluence/loadable';

export const AdvancedSearch = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AdvancedSearch" */ './AdvancedSearch'))
			.AdvancedSearch,
});
